<template>
  <div class="rootDiv">
    <a-form-model
      ref="form"
      :model="form"
      :rules="rules"
      class="center formStyle"
    >
      <h2>重新设置密码</h2>
      <a-form-model-item label="邮箱" prop="email">
        <a-input v-model="form.email" />
      </a-form-model-item>
      <a-form-model-item label="验证码" prop="verify_code">
        <a-input v-model="form.verify_code" />
        <a-input
          type="button"
          :value="getCodeButton"
          @click="getCode"
          :disabled="getCodeButtonTime !== 60"
        ></a-input>
      </a-form-model-item>
      <a-form-model-item label="密码" prop="password1">
        <a-input v-model="form.password1" type="password" />
      </a-form-model-item>
      <a-form-model-item label="确认密码" prop="password2">
        <a-input v-model="form.password2" type="password" />
      </a-form-model-item>
      <a-button type="primary" @click="restPwd"> 重置密码 </a-button>
    </a-form-model>
  </div>
</template>

<script>
import util from '../util.js'
export default {
  data() {
    const checkPwd2 = (rule, value, callback) => {
      if (value !== this.form.password1) {
        return callback(new Error('两次密码不一致'))
      } else {
        return callback()
      }
    }
    return {
      form: { email: '', password1: '', password2: '', verify_code: '' },
      rules: {
        email: [{ required: true, message: '请输入邮箱', trigger: 'blur' }],
        verify_code: [
          { required: true, message: '请输入验证码', trigger: 'blur' }
        ],
        password1: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { validator: util.checkPwd, tirgger: 'change' }
        ],
        password2: [
          { required: true, message: '请重新输入确认密码', trigger: 'blur' },
          { validator: checkPwd2, tirgger: 'change' }
        ]
      },
      getCodeButton: '获取验证码',
      getCodeButtonTime: 60
    }
  },
  methods: {
    async getCode() {
      this.getCodeButtonTime -= 1
      this.getCodeButton = `${this.getCodeButtonTime}秒后重新获取`
      const count = setInterval(() => {
        if (this.getCodeButtonTime > 0) {
          this.getCodeButtonTime -= 1
          this.getCodeButton = `${this.getCodeButtonTime}秒后重新获取`
        } else {
          this.getCodeButtonTime = 60
          this.getCodeButton = '获取验证码'
          clearInterval(count)
        }
      }, 1000)
      const resp = await this.$http.get(
        `/forget_password_verify_code/${this.form.email}`
      )
      if (resp.status !== 200) {
        clearInterval(count)
        this.getCodeButtonTime = 60
        this.getCodeButton = '获取验证码'
      }
    },
    async restPwd() {
      const result = await this.$refs.form.validate()
      if (result) {
        const resp = await this.$http.post(
          '/forget_password/reset_password',
          this.form
        )
        if (resp.status === 200) {
          this.$router.push('/login')
        }
      }
    }
  }
}
</script>

<style scoped>
.center {
  margin: auto; /*水平居中*/
  position: relative; /*设置position属性*/
  padding-top: 3rem;
  /* transform: translateY(-50%); */
}
.formStyle {
  width: 35rem;
  background-color: #fff;
  padding: 3rem 4rem 3rem 4rem;
  box-shadow: 6px 6px 8px #999;
}
.rootDiv {
  height: 100%;
}
</style>
